import { Node } from "@tiptap/core";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import Tab from "./Tab.svelte";
import { SvelteSSRRenderer } from "$components/editor/utils";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    tabNode: {
      /**
       * Add a new tab node
       */
      addTabNode: (attributes: {
        id: string;
        title: string;
        pos: any;
        blockId: string;
      }) => ReturnType;
    };
  }
}

export default Node.create({
  name: "tabNode",
  group: "tabNode",
  content: "block*",
  defining: true,
  isolating: true, // trap cursor inside tab node

  addAttributes() {
    return {
      id: { default: "" },
      title: { default: "" },
      blockId: { default: "" },
    };
  },

  addCommands() {
    return {
      addTabNode:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContentAt(
            { from: attributes.pos + 1, to: attributes.pos + 1 },
            {
              type: "tabNode",
              attrs: {
                id: attributes.id,
                title: attributes.title,
                blockId: attributes.blockId,
              },
              content: [
                {
                  type: "paragraph",
                },
              ],
            }
          );
        },
    };
  },

  parseHTML() {
    return [
      {
        tag: "tab-node",
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    return SvelteSSRRenderer("tab", Tab, { node, hasContent: true, attributes: HTMLAttributes });
  },

  addNodeView() {
    return SvelteNodeViewRenderer(Tab);
  },
});
